import { FileFieldResponse } from "@/models/form";
import { Menu } from "@headlessui/react";
import {
  DownloadIcon,
  Ellipsis,
  EllipsisVerticalIcon,
  FileUpIcon,
  MessageCircle,
  Sparkle,
  SparklesIcon,
} from "lucide-react";
import React, { useState } from "react";

interface Props {
  file: FileFieldResponse;
}

export const FileResponseField = ({ file }: Props) => {
  const [open, setOpen] = useState(false);

  const handleEllipsisClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    setOpen(true);
  };

  const handleFileClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    window.open(file.url, "_blank");
  };

  return (
    <div className="relative">
      <div
        className="flex group items-center dark:hover:bg-zinc-800 hover:bg-zinc-100 transition duration-500 ease-in-out p-2 rounded-lg cursor-pointer"
        onClick={handleFileClick}
      >
        <div>
          <FileUpIcon className="h-4 w-4 text-gray-400" />{" "}
        </div>
        <div className="ml-2">
          <h4 className="text-gray-400 truncate">{file.name}</h4>
        </div>
        <div className="ml-4 flex items-center flex-1 justify-end cursor-pointer">
          <DownloadIcon className="h-4 w-4 mr-1" />
        </div>
        {!open && (
          <div
            className="ml-4 flex items-center flex-1 justify-end text-green-500 cursor-pointer mr-1"
            onClick={handleEllipsisClick}
          >
            <SparklesIcon className="h-4 w-4 mr-1" />
            Ask AI
          </div>
        )}
      </div>

      {open && (
        <div className="mt-2">
          <div className="absolute w-full z-40 dark:bg-zinc-800 p-2 border border-white/10 bg-zinc-50 rounded-lg">
            <div>
              This insurance document provides cover for{" "}
              <span className="font-semibold">
                Public Liability, Employers’ Liability, and Property Damage.{" "}
              </span>
              <br />
              <br />
              <ul className="list-disc pl-5">
                <li>
                  Public Liability is explicitly included and provides up to
                  €6.5 million in coverage for third-party injury or property
                  damage.
                </li>
                <li>
                  Employers’ Liability covers up to €13 million for claims from
                  employees.
                </li>
                <li>
                  Property Damage includes cover for loss or damage to
                  equipment, subject to specified terms and exclusions.
                </li>
              </ul>
              <br />
              <p>The document also notes that: </p>
              <ul className="list-disc pl-5">
                <li>
                  Cover is event-specific, valid from 1st January 2025 to 31st
                  December 2025.
                </li>
                <li>
                  {" "}
                  You are required to comply with all safety and risk management
                  procedures outlined.
                </li>
                <li>
                  {" "}
                  Certain activities or high-risk equipment (e.g. inflatables,
                  pyrotechnics) may need separate notification or may be
                  excluded.
                </li>
              </ul>
            </div>
            <div className="flex mt-4">
              <div className="bg-white inline-flex p-1 rounded-full">
                <SparklesIcon className="h-5 w-5 text-dark-primary" />
              </div>
              <div className="flex-1 flex items-center ml-2">
                <input
                  type="text"
                  className="w-full p-0 text-sm bg-transparent border-none dark:text-zinc-300 text-zinc-600 ring-0 focus:ring-0 focus:outline-none"
                  placeholder={`Ask AI anything about ${file.name}`}
                />
              </div>
            </div>
          </div>
          <div className="absolute w-2/5 mt-9">
            {/* <div>recommended</div> */}
          </div>
        </div>
      )}
    </div>
  );
};
